
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashionweekweb",
      function () {
        return require("private-next-pages/fashionweekweb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashionweekweb"])
      });
    }
  